// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.second-page {
  /* height: 841.89; */
  padding: 10mm;
  padding-bottom: 0;
}

.pie-card {
  margin-top: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/default/Report/SecondPage/SecondPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".second-page {\n  /* height: 841.89; */\n  padding: 10mm;\n  padding-bottom: 0;\n}\n\n.pie-card {\n  margin-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
